// extracted by mini-css-extract-plugin
module.exports = {"title":"TagsSection_title__Svpt8","logo":"TagsSection_logo__4okar","hiddenDescription":"TagsSection_hiddenDescription__XM80T"};